import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import QRCode from 'qrcode.react';

import { CopyIcon } from '../icons/copyIcon/CopyIcon';
import { useLocale } from '../../hooks/useLocale/useLocale';
import { CloseIcon } from '../icons/closeIcon/CloseIcon';

import { DisplayQrProps } from './DisplayQr.types';
import { useStyles } from './DisplayQr.styles';

export const DisplayQr = ({ isOpened, handleClose, value }: DisplayQrProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={isOpened}
      PaperProps={{ className: classes.container }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="simple-dialog-title" className={classes.titleContainer} disableTypography>
        {formatMessage({ id: 'common.qr_code' })}
        <IconButton onClick={handleClose} size="small">
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={classes.content}>
        <QRCode value={value} size={332} level="H" />
        <div className={classes.valueContainer}>
          <Typography className={classes.value}>{value}</Typography>
          <IconButton onClick={handleCopy} size="small">
            <CopyIcon className={classes.copyIcon} />
          </IconButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
